document.addEventListener('DOMContentLoaded', () => {(($) => {

//===============================================================================
// getProductDetail
//===============================================================================
const getProductDetail = (() => {
  const props = {};
  //------------------------
  props._init = () => {
    props.code = window.theme2508 ? window.theme2508.productCode : null;
    props.$desc = $('.product-single__description');
    if (!props.code || !props.$desc[0]) return;
    props._get();
  };
  //------------------------
  props._get = () => {
    $.ajax({
      url: `https://sokensha.co.jp/products/product_data/${(props.code + '').trim()}`,
      type: 'GET',
      dataType: 'html',
    }).done((data) => {
      if (data) props.$desc.eq(0).append($(data));
    });
  };
  //------------------------
  return props;
})();

//===============================================================================
// ececute
//===============================================================================
getProductDetail._init();

})(jQuery)});
